import { FC, ReactNode } from "react";
import { useMedia } from "shared/providers";
import { cx } from "shared/utils";

interface PropertyDetailItemProps {
  label: string;
  value: ReactNode;
  labelClassName?: string;
  valueClassName?: string;
  icon?: ReactNode;
}

export const PropertyDetailItem: FC<PropertyDetailItemProps> = ({
  label,
  value,
  labelClassName,
  valueClassName,
  icon
}) => {
  const { isMobile } = useMedia();

  if (isMobile && icon)
    return (
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {icon}
          <p
            className={cx(
              "font-medium text-sm text-content-500",
              labelClassName
            )}
          >
            {label}
          </p>
        </div>
        <p
          className={cx(
            "font-medium text-sm text-content-500 truncate max",
            valueClassName
          )}
        >
          {value}
        </p>
      </div>
    );

  return (
    <div>
      <p
        className={cx(
          "m-0 text-sm font-normal text-content-400",
          labelClassName
        )}
      >
        {label}
      </p>
      <p
        className={cx(
          "m-0 text-sm font-medium text-content-1000 truncate max-w-[200px]",
          valueClassName
        )}
      >
        {value}
      </p>
    </div>
  );
};
